export default __webpack_public_path__ + "static/logo-vilco-5145f364022e1984003584874f15eccd.jpg";